import { SkeletonText, SkeletonTextLine } from '@vp/swan';
import { Currency, PriceFromFloat } from '@99designs/design-services-common';
import { __ } from '@99designs/i18n';

type ProductOptionPriceProps = {
    price: number;
    currency: Currency;
    loading: boolean;
    disabled?: boolean;
};

export const ProductOptionPrice = ({
    price,
    currency,
    disabled,
    loading,
}: ProductOptionPriceProps) => {
    if (disabled && !loading) {
        return __('Not available');
    }

    if (loading) {
        return (
            <SkeletonText>
                <SkeletonTextLine width="narrow"></SkeletonTextLine>
            </SkeletonText>
        );
    }

    return (
        <PriceFromFloat
            amount={price}
            currency={currency}
            zeroPriceLabel={__('Included')}
            showSign
        />
    );
};
